import { useMemo, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";
import LogoutContainer from "../../Layout/LogoutContainer";
import { HeaderStyle } from "../../Common/styles/header";
import InstrumentsList from "./InstrumentsList";
import { useAppSelector } from "../../../Redux/hooks";
import { platformAdminPermissions } from "../../../utils/roles";

const Instruments = () => {
  const { platformPermissions } = useAppSelector((state) => state.user);
  const [showModal, setShowModal] = useState(false);
  const canEdit = useMemo(
    () => platformPermissions.includes(platformAdminPermissions.managePlatform),
    [platformPermissions]
  );

  return (
    <>
      <Box
        sx={{
          height: "64px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: "0px 24px",
          bgcolor: "#FFFFFF",
          borderBottom: "1px solid #E5E7EB",
        }}
      >
        <Box sx={{ ml: "auto" }}>
          <LogoutContainer />
        </Box>
      </Box>
      <Box sx={HeaderStyle}>
        <Typography fontSize={20} fontWeight="medium" color="text.primary">
          Artifacts
        </Typography>

        {canEdit && (
          <Box sx={{ ml: "auto" }}>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={() => setShowModal(true)}
            >
              New Artifact
            </Button>
          </Box>
        )}
      </Box>
      <Box sx={{ p: 2.5, height: "calc(100% - 144px)", overflow: "auto" }}>
        <InstrumentsList showModal={showModal} setShowModal={setShowModal} />
      </Box>
    </>
  );
};

export default Instruments;
